import SmartAvatar from '../SmartAvatar';

export default function GCoinAvatar({ name = '', src, size = 36, sx }) {
    const initials = (String(name || '').match(/[\p{L}\p{N}]+/gu) || []).slice(0, 2).map(word => word[0]).join('').toUpperCase();
    return <SmartAvatar src={src || undefined} alt="" aria-hidden="true" sx={{
        width: size, height: size, flexShrink: 0, borderRadius: '50%',
        bgcolor: '#30203f', color: '#e3baff', border: '1px solid #64417e',
        fontSize: Math.round(size * 0.36), fontWeight: 700, ...sx,
    }}>{initials || '?'}</SmartAvatar>;
}
